import firebase from 'firebase';

const app = firebase.initializeApp({
  apiKey: 'AIzaSyDHOntr7tbtTnpXNzwok2tAbmkUaYO2eRQ',
  authDomain: 'addon-manager.firebaseapp.com',
  databaseURL: 'https://addon-manager.firebaseio.com',
  projectId: 'addon-manager',
  storageBucket: 'addon-manager.appspot.com',
  messagingSenderId: '591550753678'
});
export const db = app.database();
export const storage = app.storage();
export const addonsRef = db.ref('addons');



// WEBPACK FOOTER //
// ./src/firebase.js